import React from 'react';
import { useParams } from 'react-router-dom';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CaseActModel } from 'app/edozvola/cases/cases.model';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { AttachmentModalVariant } from 'app/edozvola/cases/project-documents/attachment-modal/attachment-modal';
import ViewTable from 'app/shared/view-table/view-table';
import { previewCaseActFile } from 'app/edozvola/cases/cases-service';
import { fetchPreviewCaseActsQuery } from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';
import error = toast.error;

export interface ICaseActProps {
  setActForAttachments: any;
  setActAttachmentVariant: any;
}

const PreviewActsTable = (props: ICaseActProps) => {
  const { id: uuid } = useParams<{ id: string }>();

  const previewFile = (caseAct: CaseActModel) => {
    previewCaseActFile(caseAct.idCaseAct)
      .then(data => {
        if (data) {
          openFileInNewWindow(data.url)
        }
      })
      .catch(err => showToast(error, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  const openAttachmentModal = (value: CaseActModel, type: AttachmentModalVariant) => {
    props.setActForAttachments(value.idCaseAct);
    props.setActAttachmentVariant(type);
  };

  const renderCaseActTableRow = (value: CaseActModel, caseIndex: number, setFieldValue) => {
    return (
      <tr key={caseIndex} className={!value.active ? 'revoked-acts' : ''}>
        <td className="break-words-column">{value.name}</td>
        <td>{value.fileNumber}</td>
        <td className="compact-column">{convertDateFromServer(value.createdDate)}</td>
        <td>
          <div className={value.additionalText ? 'clamp-2-lines' : ''}>{value.additionalText}</div>
        </td>
        <td className="compact-column">{convertDateFromServer(value.publishStartDate)}</td>
        <td className="compact-column">{convertDateFromServer(value.publishEndDate)}</td>
        <td>
          <div className={'actions-container'}>
            {value.uploadedAtLeastOneAttachment && value.canUserSeeActDocument && (
              <TooltipWrapper message="Pregledaj priloge">
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openAttachmentModal(value, 'VIEW')} />
              </TooltipWrapper>
            )}
          </div>
        </td>
        <td>
          <span>{value.active ? 'Aktivan' : 'Opozvan'}</span>
        </td>
        <td>
          <div className={'actions-container'}>
            {value.canUserSeeActDocument && (
              <>
                {value.canUserSeeActDocument && (
                  <TooltipWrapper message="Pregledaj dokument">
                    <FontAwesomeIcon icon={'file'} className={'icon-table'} onClick={() => previewFile(value)} />
                  </TooltipWrapper>
                )}
              </>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        autoLayout
        initialPaginationColumn={'createdDate'}
        initialSortDirection={'desc'}
        renderTableRow={renderCaseActTableRow}
        fetchDataQuery={fetchPreviewCaseActsQuery}
        fetchDataProps={uuid}
        noDataMessage={'Nema akata.'}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv akta']} width={'500px'} />
        <ViewTableHeaderColumn renderSort sortKey={'fileNumber'} columnLabels={['Urudžbeni broj']} />
        <ViewTableHeaderColumn compactColumn renderSort sortKey={'createdDate'} columnLabels={['Datum urudžbiranja']} />
        <ViewTableHeaderColumn renderSort sortKey={'additionalText'} columnLabels={['Primjedba']} />
        <ViewTableHeaderColumn renderSort sortKey={'publishStartDate'} columnLabels={['Početak oglašavanja akta']} />
        <ViewTableHeaderColumn renderSort sortKey={'publishEndDate'} columnLabels={['Završetak oglašavanja akta']} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Prilozi']} width={'50px'} />
        <ViewTableHeaderColumn renderSort sortKey={'active'} columnLabels={['Status']} width={'100px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akt']} width={'50px'} />
      </ViewTable>
    </>
  );
};

export default PreviewActsTable;
